module.exports = __webpack_public_path__ + "static/img/icon1.7183fd34.png";